class Config {
    public static register() {
        //Prevent validation errors from displaying
        ko.validation.init({
            insertMessages: false
        });
    }
}

Config.register();
